

<form [formGroup]="filterForm">
  <div class="search-section">
    <span>
      <span>
        <mat-slide-toggle floatLabel="always" appearance="none" color="primary" formControlName="showPastAssignments"
          id="showPastAssignments" [(ngModel)]="showPastAssignmentsFilter" #showPastAssignments
          i18n="@@type.FirearmAssignmentLog.showPastAssignmentsFilter">
          Show Past Assignments </mat-slide-toggle>
      </span>
    </span>


    <span>
      <span>
        <mat-slide-toggle floatLabel="always" appearance="none" color="primary" formControlName="showPending"
          id="showPending" [(ngModel)]="showPendingFilter" #showPending
          i18n="@@type.FirearmAssignmentLog.showPendingFilter">
          Show Pending </mat-slide-toggle>
      </span>
    </span>

  </div>
</form>

<div class="mat-elevation-z8">
  <div class="mat-table-wrapper">
    <mat-table #table [dataSource]="dataSource" matSort matSortActive="sortDate" matSortDirection="asc"
      matSortDisableClear cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="columns.dropListDropped($event)" Group>

      <ng-container matColumnDef="firearmAssignmentId">
        <mat-header-cell [crud-column-header]="columns.column('firearmAssignmentId')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.firearmAssignmentId">
          Firearm Assignment Id
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.firearmAssignmentId | number:'1.0-2':'en-GB'}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="firearm">
        <mat-header-cell [crud-column-header]="columns.column('firearm')" *matHeaderCellDef mat-sort-header cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-smallx2"
          i18n="@@type.FirearmAssignment.firearm">
          Firearm
        </mat-header-cell>
        <mat-cell class="search-column-smallx2" *matCellDef="let element">
          {{firearmDisplay(element.firearm)}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="location.firearmStorageLocationId">
        <mat-header-cell [crud-column-header]="columns.column('location.firearmStorageLocationId')" *matHeaderCellDef
          mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-smallx2"
          i18n="@@type.FirearmAssignment.location">
          Location
        </mat-header-cell>
        <mat-cell class="search-column-smallx2" *matCellDef="let element">
          {{element.location?.firearmStorageLocationId}} - {{element.location?.description}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="rangerId">
        <mat-header-cell [crud-column-header]="columns.column('rangerId')" *matHeaderCellDef mat-sort-header cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-smallx2"
          i18n="@@type.FirearmAssignment.rangerId">
          Ranger
        </mat-header-cell>
        <mat-cell class="search-column-smallx2" *matCellDef="let element">
          {{element.ranger?.name}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="user.user">
        <mat-header-cell [crud-column-header]="columns.column('user.user')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.user">
          User
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.user?.user}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actionPending">
        <mat-header-cell [crud-column-header]="columns.column('actionPending')" *matHeaderCellDef cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.actionPending">
          Action Pending
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          <mat-icon *ngIf="element.actionPending">check_box</mat-icon><mat-icon
            *ngIf="!element.actionPending">check_box_outline_blank</mat-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="activatedBy">
        <mat-header-cell [crud-column-header]="columns.column('activatedBy')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.activatedBy">
          Activated By
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.activatedBy}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="activatedDate">
        <mat-header-cell [crud-column-header]="columns.column('activatedDate')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.activatedDate">
          Activated Date
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.activatedDate | uimDateTimeFormat}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="buApprovalRejectionReason">
        <mat-header-cell [crud-column-header]="columns.column('buApprovalRejectionReason')" *matHeaderCellDef
          mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.buApprovalRejectionReason">
          Bu Approval Rejection Reason
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.buApprovalRejectionReason}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="buApproved">
        <mat-header-cell [crud-column-header]="columns.column('buApproved')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.buApproved">
          Bu Approved
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          <mat-icon *ngIf="element.buApproved">check_box</mat-icon><mat-icon
            *ngIf="!element.buApproved">check_box_outline_blank</mat-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="buApprovedRejectedBy">
        <mat-header-cell [crud-column-header]="columns.column('buApprovedRejectedBy')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.buApprovedRejectedBy">
          Bu Approved Rejected By
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.buApprovedRejectedBy}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="buApprovedRejectedDate">
        <mat-header-cell [crud-column-header]="columns.column('buApprovedRejectedDate')" *matHeaderCellDef
          mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.buApprovedRejectedDate">
          Bu Approved Rejected Date
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.buApprovedRejectedDate | uimDateTimeFormat}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="canceledBy">
        <mat-header-cell [crud-column-header]="columns.column('canceledBy')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.canceledBy">
          Canceled By
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.canceledBy}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="canceledDate">
        <mat-header-cell [crud-column-header]="columns.column('canceledDate')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.canceledDate">
          Canceled Date
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.canceledDate | uimDateTimeFormat}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="canceledReason">
        <mat-header-cell [crud-column-header]="columns.column('canceledReason')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.canceledReason">
          Canceled Reason
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.canceledReason}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="comments">
        <mat-header-cell [crud-column-header]="columns.column('comments')" *matHeaderCellDef mat-sort-header cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.comments">
          Comments
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.comments}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="createdBy">
        <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.createdBy">
          Created By
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.createdBy}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="createdDate">
        <mat-header-cell [crud-column-header]="columns.column('createdDate')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.createdDate">
          Created Date
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.createdDate | uimDateTimeFormat}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="currentAssignment">
        <mat-header-cell [crud-column-header]="columns.column('currentAssignment')" *matHeaderCellDef cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.currentAssignment">
          Current Assignment
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          <mat-icon *ngIf="element.currentAssignment">check_box</mat-icon><mat-icon
            *ngIf="!element.currentAssignment">check_box_outline_blank</mat-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="endDate">
        <mat-header-cell [crud-column-header]="columns.column('endDate')" *matHeaderCellDef cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.endDate">
          End Date
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.endDate | uimDateTimeFormat}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="firearmAssignmentType">
        <mat-header-cell [crud-column-header]="columns.column('firearmAssignmentType')" *matHeaderCellDef
          mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.firearmAssignmentType">
          Firearm Assignment Type
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.firearmAssignmentType | refDecode:'FIREARM_ASSIGNMENT_TYPE' | async}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="lastStateChangeDate">
        <mat-header-cell [crud-column-header]="columns.column('lastStateChangeDate')" *matHeaderCellDef cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.lastStateChangeDate">
          Last State Change Date
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.lastStateChangeDate | uimDateTimeFormat}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="leadApprovalRejectionReason">
        <mat-header-cell [crud-column-header]="columns.column('leadApprovalRejectionReason')" *matHeaderCellDef
          mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.leadApprovalRejectionReason">
          Lead Approval Rejection Reason
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.leadApprovalRejectionReason}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="leadApproved">
        <mat-header-cell [crud-column-header]="columns.column('leadApproved')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.leadApproved">
          Lead Approved
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          <mat-icon *ngIf="element.leadApproved">check_box</mat-icon><mat-icon
            *ngIf="!element.leadApproved">check_box_outline_blank</mat-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="leadApprovedRejectedBy">
        <mat-header-cell [crud-column-header]="columns.column('leadApprovedRejectedBy')" *matHeaderCellDef
          mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.leadApprovedRejectedBy">
          Lead Approved Rejected By
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.leadApprovedRejectedBy}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="leadApprovedRejectedDate">
        <mat-header-cell [crud-column-header]="columns.column('leadApprovedRejectedDate')" *matHeaderCellDef
          mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.leadApprovedRejectedDate">
          Lead Approved Rejected Date
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.leadApprovedRejectedDate | uimDateTimeFormat}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="lifecycleState">
        <mat-header-cell [crud-column-header]="columns.column('lifecycleState')" *matHeaderCellDef cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.lifecycleState">
          Lifecycle State
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.lifecycleState | refDecode:'FIREARM_ASSIGNMENT_LIFECYCLE_STATE' | async}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="locationId">
        <mat-header-cell [crud-column-header]="columns.column('locationId')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.locationId">
          Location Id
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.locationId | number:'1.0-2':'en-GB'}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="lockVersion">
        <mat-header-cell [crud-column-header]="columns.column('lockVersion')" *matHeaderCellDef cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.lockVersion">
          Lock Version
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.lockVersion | number:'1.0-2':'en-GB'}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="notifyPolice">
        <mat-header-cell [crud-column-header]="columns.column('notifyPolice')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.notifyPolice">
          Notify Police
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          <mat-icon *ngIf="element.notifyPolice">check_box</mat-icon><mat-icon
            *ngIf="!element.notifyPolice">check_box_outline_blank</mat-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nextAction">
        <mat-header-cell [crud-column-header]="columns.column('nextAction')" *matHeaderCellDef cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.nextAction">
          Pending Action
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          <span *ngIf="element.nextAction">{{element.nextAction | refDecode:'FIREARM_ASSIGNMENT_NEXT_ACTION' | async}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="personEmail">
        <mat-header-cell [crud-column-header]="columns.column('personEmail')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-smallx2"
          i18n="@@type.FirearmAssignment.personEmail">
          Email
        </mat-header-cell>
        <mat-cell class="search-column-smallx2" *matCellDef="let element">
          {{element.personEmail}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="policeNotificationReason">
        <mat-header-cell [crud-column-header]="columns.column('policeNotificationReason')" *matHeaderCellDef
          mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.policeNotificationReason">
          Police Notification Reason / Comments
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.policeNotificationReason}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="policeNotifiedDate">
        <mat-header-cell [crud-column-header]="columns.column('policeNotifiedDate')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.policeNotifiedDate">
          Police Notified Date
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.policeNotifiedDate | uimDateTimeFormat}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="previousStartedFirearmAssignmentId">
        <mat-header-cell [crud-column-header]="columns.column('previousStartedFirearmAssignmentId')" *matHeaderCellDef
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.previousStartedFirearmAssignmentId">
          Previous Started Firearm Assignment Id
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.previousStartedFirearmAssignmentId | number:'1.0-2':'en-GB'}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="sortDate">
        <mat-header-cell [crud-column-header]="columns.column('sortDate')" *matHeaderCellDef cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.sortDate">
          Sort Date
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.sortDate | uimDateTimeFormat}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <mat-header-cell [crud-column-header]="columns.column('startDate')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.startDate">
          Start Date
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.startDate | uimDateTimeFormat}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="startedBy">
        <mat-header-cell [crud-column-header]="columns.column('startedBy')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.startedBy">
          Started By
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.startedBy}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="storageType">
        <mat-header-cell [crud-column-header]="columns.column('storageType')" *matHeaderCellDef 
          mat-sort-header cdkDropList cdkDropListLockAxis="x"
          cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
          class="search-column-small" i18n="@@type.FirearmAssignment.storageType">
            Storage Type 
          </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.storageType | refDecode:'FIREARM_ASSIGNMENT_STORAGE_TYPE' | async}}
        </mat-cell>
      </ng-container>  

      <ng-container matColumnDef="updatedBy">
        <mat-header-cell [crud-column-header]="columns.column('updatedBy')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.updatedBy">
          Updated By
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.updatedBy}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="updatedDate">
        <mat-header-cell [crud-column-header]="columns.column('updatedDate')" *matHeaderCellDef mat-sort-header
          cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.updatedDate">
          Updated Date
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.updatedDate | uimDateTimeFormat}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="username">
        <mat-header-cell [crud-column-header]="columns.column('username')" *matHeaderCellDef mat-sort-header cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.username">
          Username
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          {{element.username}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="withExpiredStartToken">
        <mat-header-cell [crud-column-header]="columns.column('withExpiredStartToken')" *matHeaderCellDef cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.withExpiredStartToken">
          With Expired Start Token
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          <mat-icon *ngIf="element.withExpiredStartToken">check_box</mat-icon><mat-icon
            *ngIf="!element.withExpiredStartToken">check_box_outline_blank</mat-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="withStartToken">
        <mat-header-cell [crud-column-header]="columns.column('withStartToken')" *matHeaderCellDef cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
          i18n="@@type.FirearmAssignment.withStartToken">
          With Start Token
        </mat-header-cell>
        <mat-cell class="search-column-small" *matCellDef="let element">
          <mat-icon *ngIf="element.withStartToken">check_box</mat-icon><mat-icon
            *ngIf="!element.withStartToken">check_box_outline_blank</mat-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions" stickyEnd>
        <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
          <span i18n="@@common.actions">Actions</span>
          <app-column-picker-dialog-launcher [columns]="columns">
          </app-column-picker-dialog-launcher>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
          <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
            [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit"
            id="actions.edit">Edit</button>
          <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)"
            mat-raised-button color="primary" [routerLink]="viewRoute(element)" i18n="@@actions.view"
            id="actions.view">View</button>
          <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
            (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
      <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

    </mat-table>
  </div>
  <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>